import { format } from "date-fns";

// reformat to ISO 8601 for Safari
export const formatDate = date =>
  format(
    new Date(date.replace(" ", "T").split(".")[0]),
    "MMMM do yyyy, H:mm:ss",
  );

export const createExampleTour = () => ({
  title: "Example Tour",
  token: "00-0000",
  updated: { date: new Date().toString() },
  data: {
    startingImage: "118",
    images: {
      117: {
        id: "117",
        name: "Image",
        x: -10,
        y: -5,
        urls: {
          full: "https://movein.theatro360.com/uploads/event_images/59ce3caf6ec19063134533.jpg",
          low: "https://movein.theatro360.com/api/images/load/117/low",
        },
        hotspots: [],
      },
      118: {
        id: "118",
        name: "Image",
        x: 0,
        y: 12,
        urls: {
          full: "https://movein.theatro360.com/uploads/event_images/59ce3caf71185776839821.jpg",
          low: "https://movein.theatro360.com/api/images/load/118/low",
        },
        hotspots: [
          {
            type: "link",
            u: 0.5,
            v: 0.5,
            tooltip: "Hi",
            options: {
              id: "121",
            },
          },
        ],
      },
      121: {
        id: "121",
        name: "Image",
        x: 15,
        y: -10,
        urls: {
          full: "https://movein.theatro360.com/uploads/event_images/59d233b551713082813695.jpg",
          low: "https://movein.theatro360.com/api/images/load/121/low",
        },
        hotspots: [],
      },
    },
  },
});
function firstLetterUpper(theString) {
  /* eslint-disable-next-line */
  var newString = theString.replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
    return c.toUpperCase();
  });
  return newString;
}

export const formatName = name => {
  // Capitalise first letter of each word.
  let newName = name.replace(/&nbsp;/g, "");
  newName = newName.charAt(0).toUpperCase() + newName.substr(1);
  newName = firstLetterUpper(newName);
  return newName;
};

export const FONT_OPTS = [
  {
    label: 'Default',
    value: undefined,
  },
  {
    label: "Daytona Pro",
    value: "DaytonaPro",
  },
  {
    label: "Futura Pt",
    value: "futura-pt"
  },
  {
    label: "Montserrat",
    value: "Montserrat",
  },
]
